import { RiNotificationBadgeLine } from "@remixicon/react";
import React from "react";
import { Ticket } from "../../../contexts/selection-state/selection-state";
import useSelectionState from "../../../contexts/selection-state/SelectionStateContext";
import { useMarkUnreadMutation } from "../../../__generated__/api";
import { useRegisterAction, useTicketState } from "../../../contexts/ticket-state";
import { ActionType, HANDLER_INTERFACE } from "../../../contexts/ticket-state/action-registry";
import useLogging from "../../../contexts/logging/LoggingContext";
import useKeyboardShortcuts from "../../../contexts/KeyboardShortcutContext";

export default function MarkUnread(): null {
    const selectionState = useSelectionState();
    const ticketState = useTicketState();
    const logging = useLogging();

    const [markUnread] = useMarkUnreadMutation();

    const markSelectedUnread = async (tickets?: Ticket[]) => {
        const selected = tickets
            ?? ticketState?.selectionState.current?.toIdList("chat")
            ?? selectionState?.getSelection();
        selectionState?.closeCurrent();

        if (ticketState) {
            tickets?.forEach(ticket => {
                ticketState.tickets.get(ticket.id).markUnreadLocal();
                ticketState.tickets.get(ticket.id).closeIfOpen();
            });
        }

        await markUnread({
            variables: {
                chatIds: selected.map(item => item.id),
            },
        });
    };

    useKeyboardShortcuts(shortcuts => {
        shortcuts.on({
            shortcut: "k+c",
            description: "Marks selected conversations as unread",
            group: "Conversations",
            context: "default",
            handler: () => {
                if (selectionState) {
                    selectionState.markUnread(...selectionState.getSelection().toIdList("id"));
                } else {
                    markSelectedUnread();
                }
            },
        });
    });

    useRegisterAction({
        createBulkActionButton(items) {
            return items.some(row => !row.isUnread) ? {
                text: "Mark Unread",
                icon: <RiNotificationBadgeLine />,
                variant: "ghost-gray",
            } : undefined;
        },
        handleBulkAction(handler) {
            handler.items.forEach(row => {
                row.markUnreadLocal();
                row.closeIfOpen();
            });
            handler.done();
            logging.wrap(async () => {
                await markUnread({
                    variables: {
                        chatIds: handler.items.toIdList("id"),
                    },
                });
            });
        },
    }, ActionType.MARK_UNREAD);

    selectionState.registerMarkUnreadHandler(markSelectedUnread);

    return null;
}

HANDLER_INTERFACE.register(MarkUnread);
